import React, { useEffect, useState, } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Checkbox = ({ id, name, label, text, checked, disabled, required, onChange, dataCy, children, }) => {
    const [isInternalChecked, setInternalChecked] = useState(!!checked);
    useEffect(() => setInternalChecked(!!checked), [checked]);
    const [isInternalRequired, setInternalRequired] = useState(!!required);
    const handleChange = (event) => {
        if (isInternalRequired) {
            setInternalRequired(false);
        }
        setInternalChecked(event.target.checked);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleInvalid = (event) => {
        if (!disabled) {
            event.preventDefault();
            setInternalRequired(true);
        }
    };
    return (React.createElement("div", { className: classNames(midas.formGroup, isInternalRequired && midas.hasWarning), "data-cy": dataCy },
        label && (React.createElement("label", { className: midas.formLabel, htmlFor: id },
            label,
            " ",
            !!required && React.createElement("span", null, "*"))),
        React.createElement("label", { className: midas.formCheckbox, htmlFor: id },
            React.createElement("input", { id: id, name: name, type: "checkbox", checked: isInternalChecked, onChange: handleChange, disabled: disabled, required: !!required, onInvalid: handleInvalid }),
            React.createElement("i", { className: midas.formIcon }),
            " ",
            text || React.createElement("span", null, "\u00A0"),
            children),
        isInternalRequired && typeof required === 'string' && (React.createElement("div", { className: midas.formInputHint }, required))));
};
export default Checkbox;
